import React from 'react';
import "../App.css";
import Home from "./Home";
import Snow from "./Snow";
import BackToHomePage from "./BackToHomePage";

class CurrentWork extends Home{

    constructor(props){
        super(props);
    }
    
    render(){
    return (

        <div className={this.state.scale}>
            <Snow></Snow>

            <h1 className="my-12 text-center text-white text-3xl md:text-4xl font-black">Currently working :</h1>
            <h1 className="my-12 text-center text-white text-3xl md:text-4xl font-black">1. SIMM - smart investments project</h1>
            <h1 className="my-12 text-center text-white text-3xl md:text-4xl font-black">You can track progress <a className="underline" target="_blank" href="https://github.com/milanm98/SIMM">here</a></h1>                  
            <h1 className="my-12 text-center text-white text-3xl md:text-4xl font-black">2. Mobile design for chess website :</h1>
            <h1 className="my-12 text-center text-white text-3xl md:text-4xl font-black">You can track progress <a className="underline" target="_blank" href="https://github.com/milanm98/ChessClub-website">here</a></h1>                  

            <BackToHomePage></BackToHomePage>
        
        </div>

    )}
}


export default CurrentWork;